module.exports = __webpack_public_path__ + "img/header.23fe4892.jpg";